/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesFriendsGetFriendsResponseFriendDataFromJSON, FxIdWebFeaturesFriendsGetFriendsResponseFriendDataToJSON, } from './FxIdWebFeaturesFriendsGetFriendsResponseFriendData';
/**
 * Check if a given object implements the FxIdWebFeaturesFriendsGetFriendsResponse interface.
 */
export function instanceOfFxIdWebFeaturesFriendsGetFriendsResponse(value) {
    if (!('Friends' in value) || value['Friends'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFriendsGetFriendsResponseFromJSON(json) {
    return FxIdWebFeaturesFriendsGetFriendsResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsGetFriendsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Friends': (json['Friends'].map(FxIdWebFeaturesFriendsGetFriendsResponseFriendDataFromJSON)),
    };
}
export function FxIdWebFeaturesFriendsGetFriendsResponseToJSON(json) {
    return FxIdWebFeaturesFriendsGetFriendsResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsGetFriendsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Friends': (value['Friends'].map(FxIdWebFeaturesFriendsGetFriendsResponseFriendDataToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesFriendsGetFriendsResponse.js.map